import { render, staticRenderFns } from "./providersSearch.vue?vue&type=template&id=27768fbc&scoped=true&"
import script from "./providersSearch.vue?vue&type=script&lang=js&"
export * from "./providersSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27768fbc",
  null
  
)

export default component.exports